import TinymceEditorComponent from '72cms-ui/components/form-elements/TinymceEditorComponent';

export default {
    sections: ['details'],
    toolbar: ['add', 'edit', 'active', 'delete'],
    fields: {
        name: {
            section: 'details',
            position: 0,
        },
        content: {
            section: 'details',
            position: 1,
            // component: TinymceEditorComponent,
        },
        position: {
            disabled: true,
        },
    }
}



// WEBPACK FOOTER //
// ./resources/assets/cms/js/config/form.page_tab.js